import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { AjouteAvisRestaurant, AfficheCritereAvis } from '../Api/FinalReservationApi';
import Logo from '../Image/logo.png';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import { toast } from 'react-toastify';
import '../Css/depotAvis1.css';

const DepotAvis1 = () => {
    const [valueQualiter, setValueQualiter] = useState(0);
    const [valuePrestation, setValuePrestation] = useState(0);
    const [valueCadre, setValueCadre] = useState(0);
    const [commentaire, setCommentaire] = useState('');
    const [commentaireError, setCommentaireError] = useState('');
    const [loading, setLoading] = useState(false);
    const [loadingCritere, setLoadingCritere] = useState(false);

    const { nomRestaurant, idRestaurant, adresse, jour, heure, personne, idReservation, idClient } = useParams();

    let location = useLocation();
    let navigate = useNavigate();


    const [qualiter, setQualiter] = useState([
        {
            id: 1,
            note: 0,
            name: "Très décevant",
            status: false
        }, {
            id: 2,
            note: 1,
            name: "Décevant",
            status: false
        }, {
            id: 3,
            note: 5,
            name: "Correct",
            status: false
        },
        {
            id: 4,
            note: 8,
            name: "Bien",
            status: false
        },
        {
            id: 5,
            note: 10,
            name: "Très Bien",
            status: false
        }
    ]);
    const [prestation, setPrestation] = useState([
        {
            id: 1,
            note: 0,
            name: "Très décevant",
            status: false
        }, {
            id: 2,
            note: 1,
            name: "Décevant",
            status: false
        }, {
            id: 3,
            note: 2.5,
            name: "Correct",
            status: false
        },
        {
            id: 4,
            note: 3.5,
            name: "Bien",
            status: false
        },
        {
            id: 5,
            note: 5,
            name: "Très Bien",
            status: false
        }
    ]);
    const [cadre, setCadre] = useState([
        {
            id: 1,
            note: 0,
            name: "Très décevant",
            status: false
        }, {
            id: 2,
            note: 1,
            name: "Décevant",
            status: false
        }, {
            id: 3,
            note: 2.5,
            name: "Correct",
            status: false
        },
        {
            id: 4,
            note: 3.5,
            name: "Bien",
            status: false
        },
        {
            id: 5,
            note: 5,
            name: "Très Bien",
            status: false
        }
    ]);

    const handleChangeStatusQualiter = (el) => {
        setQualiter((prev) => {
            return prev.map((item) => {
                if (item.id === el.id) {
                    return { ...item, status: !item.status };
                } else {
                    return { ...item, status: false };
                }
            })
        });

        setValueQualiter(el.note);
    }


    const handleChangeStatusPrestation = (el) => {
        setPrestation((prev) => {
            return prev.map((item) => {
                if (item.id === el.id) {
                    return { ...item, status: !item.status };
                } else {
                    return { ...item, status: false };
                }
            })
        });

        setValuePrestation(el.note);
    }

    const handleChangeStatusCadre = (el) => {
        setCadre((prev) => {
            return prev.map((item) => {
                if (item.id === el.id) {
                    return { ...item, status: !item.status };
                } else {
                    return { ...item, status: false };
                }
            })
        });

        setValueCadre(el.note);
    }








    const [critere, setCritere] = useState([]);



    useEffect(() => {
        setLoadingCritere(true);
        AfficheCritereAvis().then(function (response) {
            console.log('Data Critere Avis=>', response.data.donner);
            response.data.donner.forEach((element, index) => {
                setCritere((prev) => [...prev, { id: index + 1, reponse: "", name: element.critere, status: false }]);
            });
        }).catch(function (error) {
            console.log(error);
        }).finally(function () {
            setLoadingCritere(false);
        });

    }, []);





    const handleChangeStatusCritere = (id, value) => {
        setCritere((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, status: !item.status, reponse: value };
                } else {
                    return { ...item, status: false };
                }
            })
        })



    }


    const formatPersonne = (personne) => {
        if (personne > 1) {
            return personne + " personnes";
        } else {
            return personne + " personne";
        }
    }


    const viewNote = () => {
        let total = valueQualiter + valuePrestation + valueCadre;
        return total;
    }





    const handleAddAvis = () => {
        const critereActif = critere.filter((el) => el.status === true);

        console.log("Critere actif=>", critereActif);

        if (commentaire !== "") {
            setLoading(true);
            const data = { avis: commentaire, note: viewNote(), idRestaurant: idRestaurant, idClient: idClient, idReservation: idReservation, avisRestaurant: critereActif };
            AjouteAvisRestaurant(data).then(function (response) {
                console.log(response);
                if (response.data.title === "success") {
                    toast.success(response.data.message);
                    setCommentaire('');
                    setValueCadre('');
                    setValuePrestation('');
                    setValueQualiter('');
                    navigate('/depotAvisProduit', { state: { nomRestaurant: nomRestaurant, adresse: adresse, idRestaurant: idRestaurant, idReservation: idReservation, idClient: idClient, jour: jour, heure: heure, personne: personne, idAvis: response.data.donner.idAvis } });
                }
            }).catch(function (error) {
                console.log(error);
                if (error) {
                    toast.error(error.response.data?.message);
                }

            }).finally(function () {
                setLoading(false);
            });
        } else {
            setCommentaireError('Le champ avis ne doit pas être vide !');
            const timer = setTimeout(() => setCommentaireError(''), 3000);
            return () => clearTimeout(timer);
        }

    }



    return (
        <div>
            <Helmet>
                <title>Depot avis restaurant</title>
                <meta name='description' content='Depot avis restaurant' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <div className='depotAvis1'>
                <div className='depotAvisContent'>

                    <div className='deposAvisLogo'>
                        <img src={Logo} alt="logo restaurant" width="100px" />
                    </div>

                    <div className='avis1_header'>

                        <div className='apropos'>
                            <h1>Avis sur le restaurant : <span>{nomRestaurant}</span> </h1>
                            <h2>Adresse {adresse}</h2>
                            <span>Réservation du {jour} à {heure} pour {formatPersonne(personne)}</span>
                            <div><span>N° de séservation {idReservation}</span></div>
                        </div>
                        <div className='note'>
                            <span>{viewNote()}</span>
                        </div>
                    </div>
                    <div className='avis1_body'>
                        <div className='avis1_itemNote'>
                            <div className='avis1_item'>
                                <h2>Comment avez-vous trouvé la qualité des plats ? Et la quantité ?</h2>
                                <div className='item_qualiter'>
                                    {qualiter.map((el, index) => {
                                        return (
                                            <div className="form-check form-check-inline" key={index}>
                                                <input className="form-check-input" type="radio" name="flexRadioDefaultQualiter" onChange={() => handleChangeStatusQualiter(el)} checked={el.status} id={el.id + "flexCheckDefaultQualiter"} value={"optionQualiter" + el.id} />
                                                <label className="form-check-label" htmlFor={el.id + "flexCheckDefaultQualiter"}>
                                                    {el.name}
                                                </label>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className='avis1_item'>
                                <h2>Comment s’est passé l’accueil et le service durant la prestation </h2>
                                <div className='item_prestation'>
                                    {prestation.map((el, index) => {
                                        return (
                                            <div className="form-check form-check-inline" key={index}>
                                                <input className="form-check-input" type="radio" name="flexRadioDefaultPrestation" onChange={() => handleChangeStatusPrestation(el)} checked={el.status} id={el.id + "flexCheckDefaultPrestation"} value={"optionPrestation" + el.id} />
                                                <label className="form-check-label" htmlFor={el.id + "flexCheckDefaultPrestation"}>
                                                    {el.name}
                                                </label>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className='avis1_item'>
                                <h2>Comment avez-vous trouvé le cadre du restaurant ?</h2>
                                <div className='item_cadre'>
                                    {cadre.map((el, index) => {
                                        return (
                                            <div className="form-check form-check-inline" key={index}>
                                                <input className="form-check-input" type="radio" name="flexRadioDefaultCadre" onChange={() => handleChangeStatusCadre(el)} checked={el.status} id={el.id + "flexCheckDefaultCadre"} value={"optionCadre" + el.id} />
                                                <label className="form-check-label" htmlFor={el.id + "flexCheckDefaultCadre"}>
                                                    {el.name}
                                                </label>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>








                        {critere.length !== 0 ?
                            <div className='avis1_itemCritère'>
                                {loadingCritere === true ?
                                    <p>Chargement ...</p>

                                    : critere.map((item, index) => {
                                        return (
                                            <div className='avis1_item' key={index}>
                                                <h2>{item.name}</h2>
                                                <div className='item_autre'>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name={item.name + "inlineRadioOptions"} onChange={() => handleChangeStatusCritere(item.id, "Très décevant")} id={item.name + "inlineRadio1"} defaultValue={item.name + "optionTresDecevent"} />
                                                        <label className="form-check-label" htmlFor={item.name + "inlineRadio1"} >Très décevant</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name={item.name + "inlineRadioOptions"} onChange={() => handleChangeStatusCritere(item.id, "Décevant")} id={item.name + "inlineRadio2"} defaultValue={item.name + "optionDecevent"} />
                                                        <label className="form-check-label" htmlFor={item.name + "inlineRadio2"}>Décevant</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name={item.name + "inlineRadioOptions"} onChange={() => handleChangeStatusCritere(item.id, "Correct")} id={item.name + "inlineRadio3"} defaultValue={item.name + "optionCorrect"} />
                                                        <label className="form-check-label" htmlFor={item.name + "inlineRadio3"}>Correct</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name={item.name + "inlineRadioOptions"} onChange={() => handleChangeStatusCritere(item.id, "Bien")} id={item.name + "inlineRadio4"} defaultValue={item.name + "optionBien"} />
                                                        <label className="form-check-label" htmlFor={item.name + "inlineRadio4"}>Bien</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name={item.name + "inlineRadioOptions"} onChange={() => handleChangeStatusCritere(item.id, "Très Bien")} id={item.name + "inlineRadio5"} defaultValue={item.name + "optionTresBien"} />
                                                        <label className="form-check-label" htmlFor={item.name + "inlineRadio5"}>Très Bien</label>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                            </div>
                            : ""}
                        <div className='commentaire'>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlTextarea1" className="form-label">Avis </label>
                                <textarea className="form-control" value={commentaire} onChange={(e) => setCommentaire(e.target.value)} id="exampleFormControlTextarea1" rows={3} placeholder="Avis ..." />
                            </div>
                            {commentaireError !== "" ? <span className="errorValue">{commentaireError}</span> : ''}
                        </div>
                        <div className='d-flex justify-content-center'>
                            <div className='ajoute_avis1'>
                                {loading ? <Button className='btn btn_ajouteAvis' disabled>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        variant="info"
                                        className="spiner"
                                    />
                                    Loading...
                                </Button> : <button className='btn' onClick={handleAddAvis}>Déposer avis</button>}
                            </div>

                        </div>
                        <p className="version">Version 1</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DepotAvis1;